import React, { useState, useEffect } from 'react';
import Dropdown from '../../../../Assets/Dropdown';

const FavoriteUnderdog = (props) => {
    const [selection, setSelection] = useState("");
    const [critVal, setCritVal] = useState(null);
    const [err, setErr] = useState(false);
    const [initSel, setInitSel] = useState(null);
    const [critIdx, setCritIdx] = useState(null);

    // Define dropdown items array for the custom Dropdown component
    const dropdownItems = [
        { value: "home.favorite", label: "Home team is favorite" },
        { value: "home.underdog", label: "Home team is underdog" },
        { value: "away.favorite", label: "Away team is favorite" },
        { value: "away.underdog", label: "Away team is underdog" }
    ];

    const critValues = {
        "home.favorite": {
            "label": "Home team is favorite",
            "selection": "home.favorite"
        },
        "home.underdog": {
            "label": "Home team is underdog",
            "selection": "home.underdog"
        },
        "away.favorite": {
            "label": "Away team is favorite",
            "selection": "away.favorite"
        },
        "away.underdog": {
            "label": "Away team is underdog",
            "selection": "away.underdog"
        }
    };

    // run when init crit changes
    useEffect(() => {
        // check if user is editing an existing criteria
        if(props.initCrit){
            const critCopy = {...props.initCrit.crit};
            setCritVal(critCopy);
            setSelection(critCopy.selection);
            setInitSel(critCopy.selection);
            setCritIdx(props.initCrit.index);
        };
    },[props.initCrit]);

    // set submit function in parent component
    const validateSubmit = (e) => {
        e.preventDefault();
        // make sure criteria is not null
        if(critVal !== null){
            // if existing criteria was modified - add / update criteria
            if(critVal.selection !== initSel){
                // modify criteria 
                props.sysContext.changeCrit(critVal, critIdx);
            };
            props.sysContext.setStep(2);
            props.sysContext.setCritDisp(null);
        }else{
            setErr(true);
        };
    };

    // run when selection changes - update crit
    useEffect(() => {
        if(selection !== null && selection !== ""){
            let tmpCrit = critValues[selection];
            tmpCrit["type"] = "team.fav-dog";
            setCritVal(tmpCrit);
            setErr(false);
        }else if(selection === "" || selection == null){
            setCritVal(null);
        };
    },[selection]);

    return (
        <div className="space-y-6">
            <div className="border-b border-gray-200 dark:border-gray-700 pb-5">
                <h2 className="text-xl font-semibold leading-6 text-gray-900 dark:text-white">Favorite / Underdog</h2>
                <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                    Select criteria based on team's favorite or underdog status.
                </p>
            </div>

            <form className="space-y-6" onSubmit={validateSubmit}>
                <div className="space-y-2">
                    <label htmlFor="fav-dog" className="block text-sm font-medium text-gray-700 dark:text-gray-200">
                        Choose Criteria
                    </label>
                    <Dropdown
                        id="fav-dog"
                        title="Select an option"
                        items={dropdownItems}
                        activeItem={selection}
                        onSelect={setSelection}
                        className={err ? 'ring-2 ring-brand-red-500 ring-offset-2 ring-offset-white dark:ring-offset-gray-800' : ''}
                    />
                    {err && (
                        <p className="mt-2 text-sm text-brand-red-500 dark:text-brand-red-400">
                            Please make a selection, or click cancel to go back.
                        </p>
                    )}
                </div>

                <div className="flex items-center justify-end gap-3">
                    <button
                        type="button"
                        onClick={() => props.cancel()}
                        className="rounded-md bg-white dark:bg-gray-800 px-4 py-2.5 text-sm font-semibold text-gray-900 dark:text-white shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="rounded-md bg-brand-red-500 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-brand-red-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-red-500"
                    >
                        Save Criteria
                    </button>
                </div>
            </form>
        </div>
    );
};

export default FavoriteUnderdog;